import { render, staticRenderFns } from "./Cancelar.vue?vue&type=template&id=008afacb&lang=pug&"
import script from "./Cancelar.vue?vue&type=script&lang=js&"
export * from "./Cancelar.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports